import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// Target-side "Admin is requesting remote control" confirmation dialog.
// Mirrors the existing generic ConfirmDialogComponent
// (app/components/generic-modules/dialog/confirm-dialog) in structure/style,
// but with wording specific to this feature ("Allow Remote Control" / "Deny")
// per the explicit UX requirement, instead of reusing the generic Yes/No copy.
@Component({
  selector: 'fyt-remote-control-prompt',
  templateUrl: './remote-control-prompt.component.html',
  styleUrls: ['./remote-control-prompt.component.css']
})
export class RemoteControlPromptComponent {
  constructor(
    public dialogRef: MatDialogRef<RemoteControlPromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) { }

  onDeny(): void {
    this.dialogRef.close(false);
  }
}
